
export class Client {
    id:number
    name: string
    website: string
    linkedin: string
    phone: string
    contactPerson:string
    salesperson: string
}

export class Project { 
    id:number
    name: string
    description: string
    dueDate: string
    csm: string
    status: string
    additional_file_details:[] 
    additional_files: []
    assign_to: number
    assign_to_name: string
    assigned_to_group:  number
    assigned_to_group_name: string
    client_name: string
    contract_file_details: null
    contract_files: []
    created_at: string
    created_by:  number
    customer_success_manager:  number
    customer_success_manager_name: string
    due_date: string
    link_details: null
    links: []
    modified_at: string
    modified_by:  number
    project_client: number
    project_cost:number
    project_plan: string
    start_date:  string
}

export class Task { 
    id: number
    projectName: string
    task: string
    priority: string
    dueDate: string
    status: string
}

export class SearchItem {
   client:Client[]
   project:Project[]
   task:Task[]
}

export class SearchResponseModel{
    count:number
    next:string
    previous:string
    results: SearchItem[]
}
